<template>
    <div class="customer-status-setting">
				<StatusMenu :tab_name="'customerStatus'" />
        <!-- <CreateNewStatusModal :create_new.sync="modals.create_new"  v-on:closeModal="closeModal()"  /> -->
        <CreateNewCustomerStatusModal :create_new.sync="modals.create_new"  v-on:closeModal="closeModal()"  />
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Customer Status Setting</h2>
                </b-col>
                <b-col cols="6" class="text-right ">
                    <b-button variant="primary" class="btn-header" @click="openModal">Create New</b-button>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <CustomerStatusTable />
        </b-container>
    </div>
</template>

<script>
import { Tabs, TabPane } from 'element-ui'
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import StatusMenu from '@/views/Configurations/StatusMenu'
import MainStatusSettingTable from '@/views/Configurations/MainStatusSettings/MainStatusTable'
import CustomerStatusTable from '@/views/Configurations/CustomerStatusSettings/CustomerStatusTable'
import UpdateStatusModal from '@/views/Configurations/MainStatusSettings/MainStatusModals/UpdateStatusModal'
import CreateNewCustomerStatusModal from '@/views/Configurations/CustomerStatusSettings/CustomerStatusModals/CreateCustomerModal'
// import UpdateCustomerStatusModal from '@/views/Configurations/CustomerStatusSettings/CustomerStatusModals/UpdateCustomerStatusModal'

export default {
    components: {
        MainStatusSettingTable,
        RouteBreadCrumb,
        UpdateStatusModal,
        CustomerStatusTable,
        CreateNewCustomerStatusModal,
				StatusMenu,
        // UpdateCustomerStatusModal,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    data() {
        return {
            modals:{
                create_new: false,
                update_status: false,
            },
            backButton: false,
        };
    },
    methods: {
        openModal() {
            this.modals.create_new = true;
        },
        closeModal(){
            this.modals.create_new = false;
        },
    }
}
</script>